import { render, staticRenderFns } from "./UploadListItem.vue?vue&type=template&id=c0bc70b8&scoped=true&"
import script from "./UploadListItem.vue?vue&type=script&lang=js&"
export * from "./UploadListItem.vue?vue&type=script&lang=js&"
import style0 from "./UploadListItem.vue?vue&type=style&index=0&id=c0bc70b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bc70b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
